export default __webpack_public_path__ + "static/media/commas.a37696fd.svg";